module.exports = __webpack_public_path__ + "static/media/Tramedix_Logo.75160e69.png";